(function($){

	$(document).ready(function(){

		if($('.gazoo-slideshow').length) {

			$('.gazoo-slideshow').each(function(e) {

				if(!$(this).hasClass('slick-initialized')) {

					$prevArrow = $(this).siblings('.gazoo-slideshow__navigation').find('.prev-arrow');
					$nextArrow = $(this).siblings('.gazoo-slideshow__navigation').find('.next-arrow');

					$(this).on('init afterChange', function(e, slick){
					  	currentSlickIndex = String(slick.currentSlide + 1).padStart(2, '0');
					  	currentSlickCount = '/' + String(slick.slideCount).padStart(2, '0');

					  	$(this).siblings('.gazoo-slideshow__navigation').find('.nav-labels .nav-current').text(currentSlickIndex);
					  	$(this).siblings('.gazoo-slideshow__navigation').find('.nav-labels .nav-total').text(currentSlickCount);
					}).slick({
				        slidesToShow: 1,
				        slidesToScroll: 1,
				        arrows: true,
				        dots: false,
				        infinite: false,
				        autoplay: false,
				        pauseOnFocus: false,
				        pauseOnHover: false,
				        fade: true,
						prevArrow: $prevArrow,
						nextArrow: $nextArrow
				    })
				}

			});			
		}

	});
	
})(jQuery);